import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import CustomizedBreadcrumbs from "../../../components/Custom/CustomizedBreadcrumbs";
import CustomizedMenuList from "../../../components/Custom/CustomizedMenuList";
import { IBreadcrumbsAndMenu } from "../../../types/global";

const InventorySetting = () => {
  const { t } = useTranslation();

  const breadcrumbs: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.index"),
      to: "/setting",
    },
    {
      name: t("setting.inventory.index"),
    },
  ];

  const menuList: IBreadcrumbsAndMenu[] = [
    {
      name: t("setting.inventory.group_category"),
      to: "/setting/inventory/group-category",
    },
    {
      name: t("setting.inventory.category"),
      to: "/setting/inventory/category",
    },
    {
      name: t("setting.inventory.sub_category"),
      to: "/setting/inventory/sub-category",
    },
    {
      name: t("setting.inventory.brand"),
      to: "/setting/inventory/brand",
    },
    {
      name: t("setting.inventory.segment"),
      to: "/setting/inventory/segment",
    },
    {
      name: t("setting.inventory.series"),
      to: "/setting/inventory/series",
    },
    {
      name: t("setting.inventory.warehouse.index"),
      to: "/setting/inventory/warehouse",
    },
    {
      name: t("setting.inventory.location.index"),
      to: "/setting/inventory/location",
    },
    {
      name: t("setting.inventory.uom"),
      to: "/setting/inventory/uom",
    },
    {
      name: t("setting.inventory.model"),
      to: "/setting/inventory/model",
    },
    {
      name: t("setting.inventory.attribute"),
      to: "/setting/inventory/attribute",
    },
  ];

  return (
    <Fragment>
      <CustomizedBreadcrumbs breadcrumbs={breadcrumbs} />
      <CustomizedMenuList menuList={menuList} />
    </Fragment>
  );
};

export default InventorySetting;
